import SHA1 from "crypto-js/sha1";

export function objectHash(value: any): string {
  return SHA1(JSON.stringify(value)).toString();
}
